import { Injectable } from '@angular/core';
import { PageMetaService } from '../services/page-meta.service';

/**
 * Middleware to clear page metadata when navigating to a new page.
 */
@Injectable({
  providedIn: 'root'
})
export class MetaGuard {
  constructor(private meta: PageMetaService) {}

  canMatch(): boolean {
    this.meta.clearCanonicalURL();
    this.meta.clearStructuredData();
    this.meta.clearMetaDescription();
    this.meta.setAllowRobots(true);

    return true;
  }
}
